import { Row, Typography } from "@commonlibs";
import clsx from "clsx";
import useTranslate from "ui/locale/hooks/useTranslate";
import { UploadInputDisplaySize } from "../../FileUpload/UploadInputDisplay/UploadInputDisplay.types";
import { DEFAULT_SIZE_WITH_CONTROLLERS } from "../SingleImageUpload/SingleImageUpload";

export interface ImageDragProps {
    className?: string;
    style?: React.CSSProperties;
    size: UploadInputDisplaySize;
}

const ImageDrag = ({ className, size, ...rest }: ImageDragProps) => {
    const fontVariant = DEFAULT_SIZE_WITH_CONTROLLERS.includes(size) ? "body2Strong" : "body3Strong";
    const translate = useTranslate();
    return (
        <Row className={clsx("image-drag", className)} {...rest}>
            <Typography variant={fontVariant} textAlign="center">
                {translate("dropHere")}
            </Typography>
        </Row>
    );
};

export default ImageDrag;
